import { render } from "./empty-data.vue?vue&type=template&id=5ceeb455&scoped=true&ts=true"
import script from "./empty-data.vue?vue&type=script&lang=ts"
export * from "./empty-data.vue?vue&type=script&lang=ts"

import "./empty-data.vue?vue&type=style&index=0&id=5ceeb455&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ceeb455"]])

export default __exports__